import * as types from "./types";
import { payloadActionCreator } from "../../utils/actions";

export const resetCourierState = payloadActionCreator(types.RESET_COURIER_STATE);

// Zones
export const getCourierZonesRequest = payloadActionCreator(
  types.GET_COURIER_ZONES_REQUEST
);
export const getCourierZonesSuccess = payloadActionCreator(
  types.GET_COURIER_ZONES_SUCCESS
);
export const getCourierZonesFailure = payloadActionCreator(
  types.GET_COURIER_ZONES_FAILURE
);

export const createCourierZoneRequest = payloadActionCreator(
  types.CREATE_COURIER_ZONE_REQUEST
);
export const createCourierZoneSuccess = payloadActionCreator(
  types.CREATE_COURIER_ZONE_SUCCESS
);
export const createCourierZoneFailure = payloadActionCreator(
  types.CREATE_COURIER_ZONE_FAILURE
);

export const updateCourierZoneRequest = payloadActionCreator(
  types.UPDATE_COURIER_ZONE_REQUEST
);
export const updateCourierZoneSuccess = payloadActionCreator(
  types.UPDATE_COURIER_ZONE_SUCCESS
);
export const updateCourierZoneFailure = payloadActionCreator(
  types.UPDATE_COURIER_ZONE_FAILURE
);

export const deleteCourierZoneRequest = payloadActionCreator(
  types.DELETE_COURIER_ZONE_REQUEST
);
export const deleteCourierZoneSuccess = payloadActionCreator(
  types.DELETE_COURIER_ZONE_SUCCESS
);
export const deleteCourierZoneFailure = payloadActionCreator(
  types.DELETE_COURIER_ZONE_FAILURE
);

export const reorderCourierZonesRequest = payloadActionCreator(
  types.REORDER_COURIER_ZONES_REQUEST
);
export const reorderCourierZonesSuccess = payloadActionCreator(
  types.REORDER_COURIER_ZONES_SUCCESS
);
export const reorderCourierZonesFailure = payloadActionCreator(
  types.REORDER_COURIER_ZONES_FAILURE
);

// Centers
export const getCourierCentersRequest = payloadActionCreator(
  types.GET_COURIER_CENTERS_REQUEST
);
export const getCourierCentersSuccess = payloadActionCreator(
  types.GET_COURIER_CENTERS_SUCCESS
);
export const getCourierCentersFailure = payloadActionCreator(
  types.GET_COURIER_CENTERS_FAILURE
);

export const createCourierCenterRequest = payloadActionCreator(
  types.CREATE_COURIER_CENTER_REQUEST
);
export const createCourierCenterSuccess = payloadActionCreator(
  types.CREATE_COURIER_CENTER_SUCCESS
);
export const createCourierCenterFailure = payloadActionCreator(
  types.CREATE_COURIER_CENTER_FAILURE
);

export const updateCourierCenterRequest = payloadActionCreator(
  types.UPDATE_COURIER_CENTER_REQUEST
);
export const updateCourierCenterSuccess = payloadActionCreator(
  types.UPDATE_COURIER_CENTER_SUCCESS
);
export const updateCourierCenterFailure = payloadActionCreator(
  types.UPDATE_COURIER_CENTER_FAILURE
);

export const deleteCourierCenterRequest = payloadActionCreator(
  types.DELETE_COURIER_CENTER_REQUEST
);
export const deleteCourierCenterSuccess = payloadActionCreator(
  types.DELETE_COURIER_CENTER_SUCCESS
);
export const deleteCourierCenterFailure = payloadActionCreator(
  types.DELETE_COURIER_CENTER_FAILURE
);

export const reorderCourierZoneCentersRequest = payloadActionCreator(
  types.REORDER_COURIER_ZONE_CENTERS_REQUEST
);
export const reorderCourierZoneCentersSuccess = payloadActionCreator(
  types.REORDER_COURIER_ZONE_CENTERS_SUCCESS
);
export const reorderCourierZoneCentersFailure = payloadActionCreator(
  types.REORDER_COURIER_ZONE_CENTERS_FAILURE
);

// Couriers
export const getCouriersRequest = payloadActionCreator(
  types.GET_COURIERS_REQUEST
);
export const getCouriersSuccess = payloadActionCreator(
  types.GET_COURIERS_SUCCESS
);
export const getCouriersFailure = payloadActionCreator(
  types.GET_COURIERS_FAILURE
);

export const createCourierRequest = payloadActionCreator(
  types.CREATE_COURIER_REQUEST
);
export const createCourierSuccess = payloadActionCreator(
  types.CREATE_COURIER_SUCCESS
);
export const createCourierFailure = payloadActionCreator(
  types.CREATE_COURIER_FAILURE
);

export const updateCourierRequest = payloadActionCreator(
  types.UPDATE_COURIER_REQUEST
);
export const updateCourierSuccess = payloadActionCreator(
  types.UPDATE_COURIER_SUCCESS
);
export const updateCourierFailure = payloadActionCreator(
  types.UPDATE_COURIER_FAILURE
);

// Rounds
export const getCourierRoundsRequest = payloadActionCreator(
  types.GET_COURIER_ROUNDS_REQUEST
);
export const getCourierRoundsSuccess = payloadActionCreator(
  types.GET_COURIER_ROUNDS_SUCCESS
);
export const getCourierRoundsFailure = payloadActionCreator(
  types.GET_COURIER_ROUNDS_FAILURE
);

export const createCourierRoundRequest = payloadActionCreator(
  types.CREATE_COURIER_ROUND_REQUEST
);
export const createCourierRoundSuccess = payloadActionCreator(
  types.CREATE_COURIER_ROUND_SUCCESS
);
export const createCourierRoundFailure = payloadActionCreator(
  types.CREATE_COURIER_ROUND_FAILURE
);

export const updateCourierRoundRequest = payloadActionCreator(
  types.UPDATE_COURIER_ROUND_REQUEST
);
export const updateCourierRoundSuccess = payloadActionCreator(
  types.UPDATE_COURIER_ROUND_SUCCESS
);
export const updateCourierRoundFailure = payloadActionCreator(
  types.UPDATE_COURIER_ROUND_FAILURE
);

export const deleteCourierRoundRequest = payloadActionCreator(
  types.DELETE_COURIER_ROUND_REQUEST
);
export const deleteCourierRoundSuccess = payloadActionCreator(
  types.DELETE_COURIER_ROUND_SUCCESS
);
export const deleteCourierRoundFailure = payloadActionCreator(
  types.DELETE_COURIER_ROUND_FAILURE
);

// Round stops
export const getCourierRoundStopsRequest = payloadActionCreator(
  types.GET_COURIER_ROUND_STOPS_REQUEST
);
export const getCourierRoundStopsSuccess = payloadActionCreator(
  types.GET_COURIER_ROUND_STOPS_SUCCESS
);
export const getCourierRoundStopsFailure = payloadActionCreator(
  types.GET_COURIER_ROUND_STOPS_FAILURE
);

export const createCourierRoundStopRequest = payloadActionCreator(
  types.CREATE_COURIER_ROUND_STOP_REQUEST
);
export const createCourierRoundStopSuccess = payloadActionCreator(
  types.CREATE_COURIER_ROUND_STOP_SUCCESS
);
export const createCourierRoundStopFailure = payloadActionCreator(
  types.CREATE_COURIER_ROUND_STOP_FAILURE
);

export const deleteCourierRoundStopRequest = payloadActionCreator(
  types.DELETE_COURIER_ROUND_STOP_REQUEST
);
export const deleteCourierRoundStopSuccess = payloadActionCreator(
  types.DELETE_COURIER_ROUND_STOP_SUCCESS
);
export const deleteCourierRoundStopFailure = payloadActionCreator(
  types.DELETE_COURIER_ROUND_STOP_FAILURE
);

export const reorderCourierRoundStopsRequest = payloadActionCreator(
  types.REORDER_COURIER_ROUND_STOPS_REQUEST
);
export const reorderCourierRoundStopsSuccess = payloadActionCreator(
  types.REORDER_COURIER_ROUND_STOPS_SUCCESS
);
export const reorderCourierRoundStopsFailure = payloadActionCreator(
  types.REORDER_COURIER_ROUND_STOPS_FAILURE
);

// Round schedules
export const getCourierRoundSchedulesRequest = payloadActionCreator(
  types.GET_COURIER_ROUND_SCHEDULES_REQUEST
);
export const getCourierRoundSchedulesSuccess = payloadActionCreator(
  types.GET_COURIER_ROUND_SCHEDULES_SUCCESS
);
export const getCourierRoundSchedulesFailure = payloadActionCreator(
  types.GET_COURIER_ROUND_SCHEDULES_FAILURE
);

export const createCourierRoundScheduleRequest = payloadActionCreator(
  types.CREATE_COURIER_ROUND_SCHEDULE_REQUEST
);
export const createCourierRoundScheduleSuccess = payloadActionCreator(
  types.CREATE_COURIER_ROUND_SCHEDULE_SUCCESS
);
export const createCourierRoundScheduleFailure = payloadActionCreator(
  types.CREATE_COURIER_ROUND_SCHEDULE_FAILURE
);

export const deleteCourierRoundScheduleRequest = payloadActionCreator(
  types.DELETE_COURIER_ROUND_SCHEDULE_REQUEST
);
export const deleteCourierRoundScheduleSuccess = payloadActionCreator(
  types.DELETE_COURIER_ROUND_SCHEDULE_SUCCESS
);
export const deleteCourierRoundScheduleFailure = payloadActionCreator(
  types.DELETE_COURIER_ROUND_SCHEDULE_FAILURE
);

// Shifts
export const getCourierShiftsRequest = payloadActionCreator(
  types.GET_COURIER_SHIFTS_REQUEST
);
export const getCourierShiftsSuccess = payloadActionCreator(
  types.GET_COURIER_SHIFTS_SUCCESS
);
export const getCourierShiftsFailure = payloadActionCreator(
  types.GET_COURIER_SHIFTS_FAILURE
);

export const createCourierShiftRequest = payloadActionCreator(
  types.CREATE_COURIER_SHIFT_REQUEST
);
export const createCourierShiftSuccess = payloadActionCreator(
  types.CREATE_COURIER_SHIFT_SUCCESS
);
export const createCourierShiftFailure = payloadActionCreator(
  types.CREATE_COURIER_SHIFT_FAILURE
);

export const deleteCourierShiftRequest = payloadActionCreator(
  types.DELETE_COURIER_SHIFT_REQUEST
);
export const deleteCourierShiftSuccess = payloadActionCreator(
  types.DELETE_COURIER_SHIFT_SUCCESS
);
export const deleteCourierShiftFailure = payloadActionCreator(
  types.DELETE_COURIER_SHIFT_FAILURE
);

// Trips
export const getCourierTripsRequest = payloadActionCreator(
  types.GET_COURIER_TRIPS_REQUEST
);
export const getCourierTripsSuccess = payloadActionCreator(
  types.GET_COURIER_TRIPS_SUCCESS
);
export const getCourierTripsFailure = payloadActionCreator(
  types.GET_COURIER_TRIPS_FAILURE
);

export const getCourierTripTasksRequest = payloadActionCreator(
  types.GET_COURIER_TRIP_TASKS_REQUEST
);
export const getCourierTripTasksSuccess = payloadActionCreator(
  types.GET_COURIER_TRIP_TASKS_SUCCESS
);
export const getCourierTripTasksFailure = payloadActionCreator(
  types.GET_COURIER_TRIP_TASKS_FAILURE
);

export const generateCourierTripsRequest = payloadActionCreator(
  types.GENERATE_COURIER_TRIPS_REQUEST
);
export const generateCourierTripsSuccess = payloadActionCreator(
  types.GENERATE_COURIER_TRIPS_SUCCESS
);
export const generateCourierTripsFailure = payloadActionCreator(
  types.GENERATE_COURIER_TRIPS_FAILURE
);

export const getEligibleCouriersRequest = payloadActionCreator(
  types.GET_ELIGIBLE_COURIERS_REQUEST
);
export const getEligibleCouriersSuccess = payloadActionCreator(
  types.GET_ELIGIBLE_COURIERS_SUCCESS
);
export const getEligibleCouriersFailure = payloadActionCreator(
  types.GET_ELIGIBLE_COURIERS_FAILURE
);

export const assignCourierTripRequest = payloadActionCreator(
  types.ASSIGN_COURIER_TRIP_REQUEST
);
export const assignCourierTripSuccess = payloadActionCreator(
  types.ASSIGN_COURIER_TRIP_SUCCESS
);
export const assignCourierTripFailure = payloadActionCreator(
  types.ASSIGN_COURIER_TRIP_FAILURE
);

export const cancelCourierTripRequest = payloadActionCreator(
  types.CANCEL_COURIER_TRIP_REQUEST
);
export const cancelCourierTripSuccess = payloadActionCreator(
  types.CANCEL_COURIER_TRIP_SUCCESS
);
export const cancelCourierTripFailure = payloadActionCreator(
  types.CANCEL_COURIER_TRIP_FAILURE
);

// Operator workflow (Phase 4)
export const startCourierTripRequest = payloadActionCreator(
  types.START_COURIER_TRIP_REQUEST
);
export const startCourierTripSuccess = payloadActionCreator(
  types.START_COURIER_TRIP_SUCCESS
);
export const startCourierTripFailure = payloadActionCreator(
  types.START_COURIER_TRIP_FAILURE
);

export const deliverCourierTripRequest = payloadActionCreator(
  types.DELIVER_COURIER_TRIP_REQUEST
);
export const deliverCourierTripSuccess = payloadActionCreator(
  types.DELIVER_COURIER_TRIP_SUCCESS
);
export const deliverCourierTripFailure = payloadActionCreator(
  types.DELIVER_COURIER_TRIP_FAILURE
);

export const reachCourierTaskRequest = payloadActionCreator(
  types.REACH_COURIER_TASK_REQUEST
);
export const reachCourierTaskSuccess = payloadActionCreator(
  types.REACH_COURIER_TASK_SUCCESS
);
export const reachCourierTaskFailure = payloadActionCreator(
  types.REACH_COURIER_TASK_FAILURE
);

export const dispatchCourierTaskRequest = payloadActionCreator(
  types.DISPATCH_COURIER_TASK_REQUEST
);
export const dispatchCourierTaskSuccess = payloadActionCreator(
  types.DISPATCH_COURIER_TASK_SUCCESS
);
export const dispatchCourierTaskFailure = payloadActionCreator(
  types.DISPATCH_COURIER_TASK_FAILURE
);

export const outcomeCourierTaskRequest = payloadActionCreator(
  types.OUTCOME_COURIER_TASK_REQUEST
);
export const outcomeCourierTaskSuccess = payloadActionCreator(
  types.OUTCOME_COURIER_TASK_SUCCESS
);
export const outcomeCourierTaskFailure = payloadActionCreator(
  types.OUTCOME_COURIER_TASK_FAILURE
);

export const overrideGpsCourierTaskRequest = payloadActionCreator(
  types.OVERRIDE_GPS_COURIER_TASK_REQUEST
);
export const overrideGpsCourierTaskSuccess = payloadActionCreator(
  types.OVERRIDE_GPS_COURIER_TASK_SUCCESS
);
export const overrideGpsCourierTaskFailure = payloadActionCreator(
  types.OVERRIDE_GPS_COURIER_TASK_FAILURE
);

// Custody & manual jobs (Phase 5)
export const getCourierCustodyItemsRequest = payloadActionCreator(
  types.GET_COURIER_CUSTODY_ITEMS_REQUEST
);
export const getCourierCustodyItemsSuccess = payloadActionCreator(
  types.GET_COURIER_CUSTODY_ITEMS_SUCCESS
);
export const getCourierCustodyItemsFailure = payloadActionCreator(
  types.GET_COURIER_CUSTODY_ITEMS_FAILURE
);

export const createCourierCustodyItemRequest = payloadActionCreator(
  types.CREATE_COURIER_CUSTODY_ITEM_REQUEST
);
export const createCourierCustodyItemSuccess = payloadActionCreator(
  types.CREATE_COURIER_CUSTODY_ITEM_SUCCESS
);
export const createCourierCustodyItemFailure = payloadActionCreator(
  types.CREATE_COURIER_CUSTODY_ITEM_FAILURE
);

export const reconcileCourierCustodyItemRequest = payloadActionCreator(
  types.RECONCILE_COURIER_CUSTODY_ITEM_REQUEST
);
export const reconcileCourierCustodyItemSuccess = payloadActionCreator(
  types.RECONCILE_COURIER_CUSTODY_ITEM_SUCCESS
);
export const reconcileCourierCustodyItemFailure = payloadActionCreator(
  types.RECONCILE_COURIER_CUSTODY_ITEM_FAILURE
);

export const createCourierManualJobRequest = payloadActionCreator(
  types.CREATE_COURIER_MANUAL_JOB_REQUEST
);
export const createCourierManualJobSuccess = payloadActionCreator(
  types.CREATE_COURIER_MANUAL_JOB_SUCCESS
);
export const createCourierManualJobFailure = payloadActionCreator(
  types.CREATE_COURIER_MANUAL_JOB_FAILURE
);

// Reports & live monitor (Phase 6)
export const getCourierReportsRequest = payloadActionCreator(
  types.GET_COURIER_REPORTS_REQUEST
);
export const getCourierReportsSuccess = payloadActionCreator(
  types.GET_COURIER_REPORTS_SUCCESS
);
export const getCourierReportsFailure = payloadActionCreator(
  types.GET_COURIER_REPORTS_FAILURE
);

export const getCourierReportRequest = payloadActionCreator(
  types.GET_COURIER_REPORT_REQUEST
);
export const getCourierReportSuccess = payloadActionCreator(
  types.GET_COURIER_REPORT_SUCCESS
);
export const getCourierReportFailure = payloadActionCreator(
  types.GET_COURIER_REPORT_FAILURE
);

export const getCourierLiveMonitorRequest = payloadActionCreator(
  types.GET_COURIER_LIVE_MONITOR_REQUEST
);
export const getCourierLiveMonitorSuccess = payloadActionCreator(
  types.GET_COURIER_LIVE_MONITOR_SUCCESS
);
export const getCourierLiveMonitorFailure = payloadActionCreator(
  types.GET_COURIER_LIVE_MONITOR_FAILURE
);

// Optimization (Phase 7)
export const optimizeRoundStopsRequest = payloadActionCreator(
  types.OPTIMIZE_ROUND_STOPS_REQUEST
);
export const optimizeRoundStopsSuccess = payloadActionCreator(
  types.OPTIMIZE_ROUND_STOPS_SUCCESS
);
export const optimizeRoundStopsFailure = payloadActionCreator(
  types.OPTIMIZE_ROUND_STOPS_FAILURE
);

export const autoAssignCourierTripRequest = payloadActionCreator(
  types.AUTO_ASSIGN_COURIER_TRIP_REQUEST
);
export const autoAssignCourierTripSuccess = payloadActionCreator(
  types.AUTO_ASSIGN_COURIER_TRIP_SUCCESS
);
export const autoAssignCourierTripFailure = payloadActionCreator(
  types.AUTO_ASSIGN_COURIER_TRIP_FAILURE
);
